import moment from 'moment';

export function normalizeIdleTimeoutMinutes(value) {
    const timeoutMinutes = Number.parseInt(value, 10);
    if (!Number.isFinite(timeoutMinutes) || timeoutMinutes <= 0) {
        return null;
    }

    return timeoutMinutes;
}

export function shouldLogoutForInactivity(lastTimeStamp, idleTimeoutMinutes, currentTime = moment()) {
    if (!idleTimeoutMinutes) {
        return false;
    }

    const parsedTime = moment(lastTimeStamp, moment.ISO_8601, true);
    if (!parsedTime.isValid()) {
        return false;
    }

    const elapsedMinutes = moment.duration(currentTime.diff(parsedTime)).asMinutes();
    return elapsedMinutes >= idleTimeoutMinutes;
}
